module.exports = __webpack_public_path__ + "img/play-trailer-button.7ff74fa9.svg";